(function () {
  function initAgeGate(gate) {
    var storageKey = gate.getAttribute('data-storage-key') || 'ssbc:age-confirmed';
    var exitUrl = gate.getAttribute('data-exit-url') || 'https://www.google.com';
    var card = gate.querySelector('[data-age-gate-card]');
    var yesButton = gate.querySelector('[data-age-gate-yes]');
    var noButton = gate.querySelector('[data-age-gate-no]');
    var previousActive = document.activeElement;

    try {
      if (window.sessionStorage.getItem(storageKey) === 'yes') {
        gate.remove();
        return;
      }
    } catch (error) {}

    document.documentElement.classList.add('ssbc-age-gate-open');
    document.body.classList.add('ssbc-age-gate-open');

    function closeGate() {
      try {
        window.sessionStorage.setItem(storageKey, 'yes');
      } catch (error) {}
      document.documentElement.classList.remove('ssbc-age-gate-open');
      document.body.classList.remove('ssbc-age-gate-open');
      gate.remove();
      if (previousActive && typeof previousActive.focus === 'function') {
        previousActive.focus();
      }
    }

    function exitGate() {
      var title = gate.querySelector('.age-gate__title');
      var copy = gate.querySelector('.age-gate__copy');
      var actions = gate.querySelector('.age-gate__actions');
      if (title) title.textContent = 'Redirecting...';
      if (copy) copy.textContent = 'This site is intended for adults 21 and older. Sending you somewhere safe.';
      if (actions) actions.hidden = true;
      window.location.replace(exitUrl);
    }

    function trapFocus(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        return;
      }
      if (event.key !== 'Tab' || !card) return;
      var focusable = card.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    if (yesButton) yesButton.addEventListener('click', closeGate);
    if (noButton) noButton.addEventListener('click', exitGate);
    document.addEventListener('keydown', trapFocus);
    gate.addEventListener('ssbc:close', function () {
      document.removeEventListener('keydown', trapFocus);
    });
    if (yesButton) yesButton.focus();
  }

  function init() {
    document.querySelectorAll('[data-ssbc-age-gate]').forEach(initAgeGate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
